class t extends Error {
  constructor(r, o = 0) {
    super(r), this.code = o;
  }
}
export {
  t as CustomError
};
//# sourceMappingURL=customError.js.map
